module.exports = __webpack_public_path__ + "img/16-twoImg.819a20e3.png";